import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const BecomeASponsor = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Clear error when user starts typing
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.firstName && formData.email) {
      setIsLoading(true);
      setError("");

      try {
        // EmailJS IDs (the public key is meant to ship in client code; see EMAILJS_SETUP.md)
        const serviceID = "service_xlgk5m8";
        const templateID = "template_lns1d0o";
        const publicKey = "3n_qCSkkYpkCgLm_p";

        const templateParams = {
          from_name: `${formData.firstName} ${formData.lastName}`,
          from_email: formData.email,
          company: formData.company,
          to_email: "uatxcavators@gmail.com",
          subject: `New Sponsorship Inquiry${
            formData.company ? ` from ${formData.company}` : ""
          }`,
          message: `New Sponsorship Inquiry

Contact Information:
- Name: ${formData.firstName} ${formData.lastName}
- Email: ${formData.email}${
            formData.company ? `\n- Company: ${formData.company}` : ""
          }

Please follow up with this potential sponsor regarding our sponsorship tiers and opportunities.

Best regards,
UATXcavators Website`,
        };

        await emailjs.send(serviceID, templateID, templateParams, publicKey);
        setIsSubmitted(true);
      } catch (error) {
        console.error("EmailJS Error:", error);
        setError(
          "Failed to send email. Please try again or contact us directly at uatxcavators@gmail.com"
        );
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (isSubmitted) {
    return (
      <section className="sponsor-section">
        <div className="sponsor-content">
          <h2 className="sponsor-title">Thank you, {formData.firstName}!</h2>
          <p className="sponsor-subtitle">
            We have received your sponsorship inquiry
            {formData.company ? ` for ${formData.company}` : ""} and will be in
            touch soon at {formData.email}.
          </p>

          <div className="sponsor-contact">
            <p>
              Questions? Email us directly at:
              <a href="mailto:uatxcavators@gmail.com" className="sponsor-email">
                uatxcavators@gmail.com
              </a>
            </p>
            <button onClick={() => setIsSubmitted(false)} className="back-btn">
              Submit Another Inquiry
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="sponsor-section">
      <div className="sponsor-content">
        <h2 className="sponsor-title">Become a Sponsor</h2>

        {/* Contact Form */}
        <div className="sponsor-form-section">
          <p className="form-subtitle">
            Fill out the form below and we will reach out to you with more
            details.
          </p>

          <form onSubmit={handleSubmit} className="sponsor-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">First Name *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                  autoComplete="given-name"
                  placeholder="first name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  autoComplete="family-name"
                  placeholder="last name (optional)"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                autoComplete="email"
                inputMode="email"
                placeholder="email address"
              />
            </div>

            <div className="form-group">
              <label htmlFor="company">Company</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleInputChange}
                autoComplete="organization"
                placeholder="company name (optional)"
              />
            </div>

            {error && (
              <div className="error-message" role="alert">
                {error}
              </div>
            )}

            <button type="submit" className="submit-btn" disabled={isLoading}>
              {isLoading ? "Sending..." : "Send Sponsorship Inquiry"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default BecomeASponsor;
